import _ from 'lodash'
import axios from 'axios'
import jwt_decode from 'jwt-decode'

const types = {
  SET_PAGE_SETTINGS: 'setPageSettings',
  SAVE_AUTH_DATA: 'saveAuthData',
  CLEAR_AUTH_DATA: 'clearAuthData',
  UPDATE_USER: 'updateUserData',
  SET_WELCOME_MODAL: 'changeWelcomeModalStatus'
}

const state = {
  pageSettings: {
    pages: []
  },
  accessToken: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('portal.user')) || {},
  showWelcomeModal: true
}
const mutations = {
  setPageSetting(state, settings) {
    _.remove(state.pageSettings.pages, function (o) {
      return o.name == settings.name
    });
    state.pageSettings.pages.push(settings)
  },
  saveAuthData(state, payload) {
    state.user = payload.user
    state.accessToken = payload.token
    state.setWelcomeModal = true
    localStorage.setItem('token', payload.token)
    localStorage.setItem('portal.user', JSON.stringify(payload.user))
  },
  clearAuthData(state) {
    localStorage.removeItem('token')
    localStorage.removeItem('portal.user')
    state.accessToken = ''
    state.user = {}
    state.showWelcomeModal = true
    delete axios.defaults.headers.common['Authorization']
  },
  updateUserData(state, data) {
    state.user.name = data.name
    state.user.email = data.email
    localStorage.setItem('portal.user', JSON.stringify(state.user))
  },
  changeWelcomeModalStatus(state, data) {
    state.showWelcomeModal = data
  }
}

const getters = {
  getPageSettings: state => pageName => {
    if (state.pageSettings && state.pageSettings.pages) {
      const c = _.find(state.pageSettings.pages, function (o) {
        return o.name == pageName
      });
      return c ? c : null
    }
    return null
  },
  currentUser: state => {
    return state.user
  },
  isAuthenticated: state => {
    return !!state.accessToken
  },
  accessToken: state => {
    return state.accessToken
  }
};

const actions = {
  setUser({
    commit
  }, signinResponse) {
    const jwtData = jwt_decode(signinResponse.token);
    const user = {
      name: jwtData.given_name,
      email: jwtData.email,
      id: jwtData.customer_id,
      role: jwtData.role,
      parentId: 1
    }
    
    commit(types.SAVE_AUTH_DATA, {
      user: user,
      token: signinResponse.token
    })
  },
  setWelcomeModal({
    commit
  }, data) {
    commit(types.SET_WELCOME_MODAL, data)
  },
  updateUser({
    commit
  }, user) {
    commit(types.UPDATE_USER, user)
  },
  removeUser({
    commit
  }) {
    commit(types.CLEAR_AUTH_DATA)
  }
};

export default {
  state,
  mutations,
  getters,
  actions
}
